module.exports = __webpack_public_path__ + "img/icon-pdf.ee6475ae.png";